import { render, staticRenderFns } from "./DoubleInput.vue?vue&type=template&id=16145de2&scoped=true&"
import script from "./DoubleInput.vue?vue&type=script&lang=js&"
export * from "./DoubleInput.vue?vue&type=script&lang=js&"
import style0 from "./DoubleInput.vue?vue&type=style&index=0&id=16145de2&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16145de2",
  null
  
)

export default component.exports